<template>
  <BaseModal ref="BaseModal" @confirm="confirm" @close="close">
    <div class="select-base-amount-dialog">
      <SimpleTable
        width="25%"
        :showIndex="false"
        ref="tableLeft"
        :columns="columnsLeft"
        :data="tableDataLeft"
        @row-select="onRowSelectLeft"
      />
      <SimpleTable
        :loading="loading"
        width="75%"
        :showIndex="false"
        ref="tableRight"
        :columns="columnsRight"
        :data="tableDataRight"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import { tabs } from './config'
import {
  sortRecords,
  debounceAfter,
  aggregationAmount,
  aggregationSUM,
  dfsFn
} from '@/utils/index'

export default {
  name: 'SelectBaseAmountDialog',
  components: { BaseModal, SimpleTable },
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      columnsLeft: [{ field: 'label', title: '页签名称' }],
      columnsRight: [
        { field: 'name', title: '费用名称' },
        {
          field: 'checkFlag',
          title: '估算金额',
          canEdit: true,
          canModify: true,
          cellType: 'checkbox',
          multiple: true
        }
      ],

      tableDataLeft: tabs,
      tableDataRight: [],
      tableDataRightMap: {},

      currentSelectLeft: null,
      loading: false
    }
  },
  computed: {},
  watch: {},

  created() {},
  mounted() {},
  methods: {
    // 显示弹窗
    show(options = {}) {
      this.options = options
      this.$refs.BaseModal.show({
        title: '取费基数',
        confirmText: '确定',
        width: '600px'
      })

      setTimeout(this.init)
    },

    init() {
      this.$refs.tableLeft.initialized()
    },

    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      if (this.currentSelectLeft?.value === obj?.value) return
      this.currentSelectLeft = obj

      this.getRightTable()
    },

    async getRightTable() {
      if (this.tableDataRightMap[this.currentSelectLeft.value]) {
        this.tableDataRight =
          this.tableDataRightMap[this.currentSelectLeft.value]
        return
      }
      this.loading = true
      const res = await this.$service.get(
        `/${this.currentSelectLeft.value}/list`,
        { mainId: this.options.id }
      )
      this.loading = false
      const data =
        res?.data.map(e => ({
          name: e.costName || e.name,
          checkFlag: false
        })) || []
      data.push({ name: '合计', checkFlag: false })
      this.tableDataRightMap[this.currentSelectLeft.value] = sortRecords(data)
      this.tableDataRight = this.tableDataRightMap[this.currentSelectLeft.value]
    },

    confirm(close) {
      const res = []
      for (const [key, arr] of Object.entries(this.tableDataRightMap)) {
        const label = tabs.find(e => e.value === key)?.label
        arr
          .filter(e => e.checkFlag)
          .forEach(e => res.push(`${label}(${e.name})`))
      }

      this.$emit('confirm', this.options.selectedCellInfos, res.join('+'))
      close()
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.select-base-amount-dialog {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  height: 350px;
}
</style>
